import type { SaasParams } from '@/lib/api/saasApi';
import { create } from 'zustand';

interface SaasStore {
  maintenanceModeFront: boolean;
  maintenanceModeAdmin: boolean;
  openRegister: boolean;
  openCompetitionRegistration: boolean;
  referralEnabled: boolean;
  playerPlusEnabled: boolean;
  maintenanceMessage: string | null;
  /** true once the first fetch has resolved (success or failure) */
  loaded: boolean;
  setParams: (params: SaasParams) => void;
  markLoaded: () => void;
}

export const useSaasStore = create<SaasStore>()(set => ({
  maintenanceModeFront: false,
  maintenanceModeAdmin: false,
  openRegister: true,
  openCompetitionRegistration: true,
  referralEnabled: true,
  playerPlusEnabled: false,
  maintenanceMessage: null,
  loaded: false,

  setParams: params =>
    set({
      maintenanceModeFront: params.maintenanceModeFront,
      maintenanceModeAdmin: params.maintenanceModeAdmin,
      openRegister: params.openRegister,
      openCompetitionRegistration: params.openCompetitionRegistration,
      referralEnabled: params.referralEnabled,
      playerPlusEnabled: params.playerPlusEnabled,
      maintenanceMessage: params.maintenanceMessage,
      loaded: true,
    }),

  markLoaded: () => set({ loaded: true }),
}));
